import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import type { ClassNameMap } from "@material-ui/core/styles/withStyles";
import clsx from "clsx";

type Action = {
  text: string;
  disabled?: boolean;
  onClick: () => void;
  className?: string;
};

type Props = {
  open: boolean;
  title: string;
  classes: ClassNameMap;
  onClose?: () => void;
  isBigModal?: boolean;
  children: JSX.Element;
  actions?: Action[];
};

export const CustomModal = ({
  title,
  open,
  onClose,
  isBigModal,
  children,
  actions,
  classes,
}: Props) => {
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      className={clsx(classes.dialog, {
        [classes.bigModal]: isBigModal,
      })}
    >
      <DialogTitle title={title} className={classes.dialogTitle}>
        {title}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions className={classes.dialogActions}>
        {actions.map(({ text, ...btnProps }) => (
          <Button key={text} disableRipple {...btnProps}>
            {text}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

CustomModal.defaultProps = {
  isBigModal: false,
  onClose: () => null,
};
